import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { provideNgxMask } from 'ngx-mask'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { TariffTypeService } from '../../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { convertCurrency, generateHexId } from '../../../../shared/utils/utils'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatDivider } from '@angular/material/divider'
import { ItinerariesItemProposalCreateComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-create/itineraries-item-proposal-create.component'
import { ModalTariffProposalComponent } from '../../../tariff/modal-tariff-proposal/modal-tariff-proposal.component'
import moment from 'moment/moment'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import { ItinerariesItemProposalEditComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-edit/itineraries-item-proposal-edit.component'
import { DecimalInputDirective } from '../../../../shared/directives/decimalInput'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { SearchTariffProposalComponent } from '../../../tariff/search-tariff-proposal/search-tariff-proposal.component'
import { CommissionDividerService } from '../../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ProposalItemService } from '../../../../core/services/proposal/proposal-item/proposal-item.service'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { ProposalClientService } from '../../../../core/services/proposal/proposal-client/proposal-client.service'
import { PurchasesQuoteRequestItinerariesService } from '../../../../core/services/purchases/purchases-quote-request-itineraries/purchases-quote-request-itineraries.service'
import { JsonPipe } from '@angular/common'
import { ItinerariesItemProposalDuplicateComponent } from '../../../itineraries/item-proposal/itineraries-item-proposal-duplicate/itineraries-item-proposal-duplicate.component'

@Component({
  selector: 'item-proposal-duplicate-form',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    CurrencyInputDirective,
    MatCheckbox,
    MatDivider,
    ItinerariesItemProposalCreateComponent,
    IntegerInputDirective,
    ItinerariesItemProposalEditComponent,
    DecimalInputDirective,
    MatAccordion,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    SearchTariffProposalComponent,
    JsonPipe,
    ItinerariesItemProposalDuplicateComponent,
  ],
  templateUrl: './item-proposal-duplicate-form.component.html',
  styleUrl: './item-proposal-duplicate-form.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class ItemProposalDuplicateFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private commissionDividerService: CommissionDividerService,
    private proposalItemService: ProposalItemService,
    private purchasesQuoteRequestItinerariesService: PurchasesQuoteRequestItinerariesService,
    private itinerariesService: ItinerariesService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ItemProposalDuplicateFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    // this.idClient = data.idClient
    // if (data && data.edit) {
    //   this.edit = true
    //   this.item = data.item
    // }
    this.proposal = data.proposalInfo
    this.idClient =
      this.proposal.subClienteId > 0
        ? this.proposal.subClienteId
        : this.proposal.clienteId
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
      if (
        this.item.statusId == 1 ||
        this.item.statusId == 5 ||
        this.item.statusId == 6
      ) {
        this.viewOnly = true
      } else {
        this.viewOnly = false
      }
    }
  }

  // implements OnInit {
  // constructor(
  //   private formBuilder: FormBuilder,
  //   private driverTypeService: DriverTypeService,
  //   private locationService: LocationService,
  //   private serviceTypeService: ServiceTypeService,
  //   private serviceSpecificationService: ServiceSpecificationService,
  //   private vehicleTypeService: VehicleTypeService,
  //   private snackbar: SnackbarCustomService,
  //   private dialogRef: MatDialogRef<ItemProposalEditFormComponent>,
  //   @Inject(MAT_DIALOG_DATA) public data: any,
  //   private dialog: MatDialog,
  // ) {
  //   console.log('data', data)
  //   this.proposal = data.proposalInfo
  //   this.idClient =
  //     this.proposal.subClienteId > 0
  //       ? this.proposal.subClienteId
  //       : this.proposal.clienteId
  //   if (data && data.edit) {
  //     this.edit = true
  //     this.item = data.item
  //     this.viewOnly = this.item.statusId == 1
  //   }
  // }

  @ViewChild(SearchTariffProposalComponent)
  SearchTariffProposalComponent!: SearchTariffProposalComponent

  @Output() response = new EventEmitter()
  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  viewOnly: boolean = false
  proposal: any = {}
  loadingInfo: boolean = true
  tariffSelected: any = {}

  originIdEdit: any = ''
  destinationIdEdit: any = ''
  count: number = 0
  countProgress: number = 0

  edit: boolean = false
  idClient: number = -1
  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listItineraries: any[] = []
  listServiceSpecification: any[] = []
  listCommission: any[] = [
    { value: 'T', description: 'tg.mob', disabled: false },
    { value: 'C', description: 'Cliente', disabled: true },
    { value: 'P', description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ngOnInit(): void {
    // this.getLocation()
    // this.getTypeService()
    // this.getTypeVehicle()
    // this.getTypeDriver()
    this.createForm()
    this.getCommissionDivider()
    this.getCommissionDivider(this.idClient)
    // if (this.edit) {
    //   this.fillForm(this.item)
    // }
  }

  ngAfterViewInit(): void {
    if (this.edit) {
      // if (this.item.tarifario.id == '' || !this.item.tarifario.id) {
      //   if (this.SearchTariffProposalComponent) {
      //     this.SearchTariffProposalComponent.fillPurchase()
      //   }
      // }
      this.fillForm(this.item)
    }
  }

  getCommissionDivider(id: number = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          if (!this.edit) {
            this.fillCommission(this.commissionDividerTg)
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
      // this.commissionDividerService.getCommissionDividerDefault().subscribe({
      //   next: (response: ResponseRequestModel) => {
      //     this.commissionDividerTg = {
      //       taxa: response.data.taxa,
      //       divisor: response.data.divisor,
      //       comissao: response.data.comissao,
      //     }
      //     if (!this.edit) {
      //       this.fillCommission(this.commissionDividerTg)
      //     }
      //   },
      //   error: (err: ResponseRequestModel) => {
      //     console.error(err)
      //   },
      //   complete: () => {},
      // })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.listCommission[1].disabled = false
              if (!this.edit) {
                this.form.get('typeCommission')!.setValue('C')
                this.fillCommission(this.commissionDividerClient)
              }
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 1,
                comissao: 0,
              }
              this.listCommission[1].disabled = true
              if (!this.edit) {
                this.fillCommission(this.commissionDividerTg)
                this.form.get('typeCommission')!.setValue('T')
              }
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear: boolean = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(1))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(1))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(1))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 'T') {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 'C') {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
    this.calculateValues()
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')!.clearValidators()
    this.form.get('driverType')!.clearValidators()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, idService: number = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  // editItemProposal() {
  //   this.loading = true
  //   const model = this.createModel()
  //   this.response.emit(model)
  //   this.close()
  // }

  editItineraries(model: any[]) {
    this.countProgress = 0
    this.count = model.length
    for (let i = 0; i < model.length; i++) {
      this.countProgress++
      this.itiService(model[i].model, model[i].type)
    }
    this.checkClose()
  }

  checkClose() {
    if (this.count == this.countProgress) {
      this.loading = false
      this.snackbar.success('Editado com sucesso')
      this.response.emit(true)
      this.close()
    }
  }

  itiService(model: any, act: 'create' | 'edit' | 'delete') {
    if (act == 'create') {
      this.itinerariesService.createItineraries(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.count++
          this.checkClose()
        },
        error: (err: ErrorRequestModel) => {
          this.count++
          this.checkClose()
        },
        complete: () => {},
      })
    } else if (act == 'edit') {
      this.itinerariesService.editItineraries(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.count++
          this.checkClose()
        },
        error: (err: ErrorRequestModel) => {
          this.count++
          this.checkClose()
        },
        complete: () => {},
      })
    } else if (act == 'delete') {
      this.itinerariesService.deleteItineraries(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.count++
          this.checkClose()
        },
        error: (err: ErrorRequestModel) => {
          this.count++
          this.checkClose()
        },
        complete: () => {},
      })
    }
  }

  createModelIti(model: any) {
    let list: any[] = []
    if (model.itinerarios && model.itinerarios.length > 0) {
      let originIti = model.itinerarios.find((ele: any) => {
        return ele.trecho == 'O'
      })
      if (originIti && this.originIdEdit != '') {
        list.push({
          type: 'edit',
          model: {
            ...originIti,
            id: this.originIdEdit,
            itemPropostaId: this.item.id,
          },
        })
      } else if (originIti && this.originIdEdit == '') {
        list.push({
          type: 'create',
          model: { ...originIti, itemPropostaId: this.item.id },
        })
      } else if (!originIti && this.originIdEdit != '') {
        list.push({ type: 'delete', model: this.originIdEdit })
      }

      let destinationIti = model.itinerarios.find((ele: any) => {
        return ele.trecho == 'D'
      })
      if (destinationIti && this.destinationIdEdit != '') {
        list.push({
          type: 'edit',
          model: {
            ...destinationIti,
            id: this.destinationIdEdit,
            itemPropostaId: this.item.id,
          },
        })
      } else if (destinationIti && this.destinationIdEdit == '') {
        list.push({
          type: 'create',
          model: { ...destinationIti, itemPropostaId: this.item.id },
        })
      } else if (!destinationIti && this.destinationIdEdit != '') {
        list.push({ type: 'delete', model: this.destinationIdEdit })
      }
    }
    return list
  }

  editItemProposal() {
    if (this.validItem()) {
      this.loading = true
      const model = this.createModel()
      this.proposalItemService
        .createProposalItemWithItineraries(model)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.updateResquestPurchase(this.item.propostaId)
            this.snackbar.success(response.message)
            this.response.emit(true)
            this.close()
          },
          error: (err: ErrorRequestModel) => {
            this.loading = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loading = false
            // this.form.reset()
          },
        })
      // this.proposalItemService
      //   .editProposalItemWithItineraries(model)
      //   .subscribe({
      //     next: (response: ResponseRequestModel) => {
      //       this.updateResquestPurchase(this.item.propostaId)
      //       this.snackbar.success(response.message)
      //       this.response.emit(true)
      //       this.close()
      //     },
      //     error: (err: ErrorRequestModel) => {
      //       this.loading = false
      //       this.snackbar.errorRequest(err)
      //     },
      //     complete: () => {
      //       this.loading = false
      //       // this.form.reset()
      //     },
      //   })
    } else {
      this.snackbar.info(
        'Para compras/cotação, necessário tipo de serviço, serviço, endereço de Origem e Destino.',
      )
      this.loading = false
    }
  }

  updateResquestPurchase(id: any) {
    this.purchasesQuoteRequestItinerariesService
      .updateRequestPurchase(id)
      .subscribe({
        next: (response: ResponseRequestModel) => {},
        error: (err: ErrorRequestModel) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {},
      })
  }

  validItem() {
    if (this.tariffSelected.id) {
      return true
    } else {
      let element: any = this.SearchTariffProposalComponent.createPurchase()
      console.log('element', element)
      let destination: any = element.destination
      let origin: any = element.origin
      if (
        // destination.cep == '' ||
        // destination.logradouro == '' ||
        // destination.numero == '' ||
        // destination.bairro == '' ||
        destination.cidade == '' ||
        destination.estado == '' ||
        // origin.bairro == '' ||
        // origin.cep == '' ||
        // origin.logradouro == '' ||
        // origin.numero == '' ||
        origin.cidade == '' ||
        origin.estado == '' ||
        element.servicoId == 0 ||
        element.servicoId == '' ||
        element.tipoServicoId == 0 ||
        element.tipoServicoId == ''
      ) {
        return false
      } else {
        return true
      }
    }
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  getDescription(id: number, list: any[]) {
    let index = list.findIndex((ele) => {
      return ele.id == id
    })
    return index > -1 ? list[index].descricao : ''
  }

  fillForm(item: any) {
    console.log('item: ', item)
    if (item) {
      // if (item.tarifarioId != '') {
      this.tariffSelected = {
        origem: item.origem,
        origemId: item.origemId,

        destino: item.destino,
        destinoId: item.destinoId,

        tipoServico: item.tipoServico,
        tipoServicoId: item.tipoServicoId,

        servico: item.servico,
        servicoId: item.servicoId,

        tipoVeiculo: item.tipoVeiculo,
        tipoVeiculoId: item.tipoVeiculoId,

        tipoMotorista: item.tipoMotorista,
        tipoMotoristaId: item.tipoMotoristaId,

        tarifarioId: item.tarifarioId,
        id: item.tarifarioId,

        tipoTarifarioId: item.tipoTarifarioId,

        perimetroUrbano: item.perimetroUrbano,
        standard: item.standard,
      }

      if (item.itinerarios) {
        let destination = item.itinerarios.find((ele: any) => {
          return ele.trecho == 'D'
        })
        if (destination) {
          this.destinationIdEdit = destination.id
          this.tariffSelected.destination = {
            cep: destination.cep,
            logradouro: destination.logradouro,
            numero: destination.numero,
            complemento: destination.complemento,
            bairro: destination.bairro,
            cidade: destination.cidade,
            estado: destination.estado,
            latitude: destination.latitude,
            longitude: destination.longitude,
            // descricao: item.destino,
            descricao: destination.localParada,
          }
        }

        let origin = item.itinerarios.find((ele: any) => {
          return ele.trecho == 'O'
        })
        if (origin) {
          this.originIdEdit = origin.id
          this.tariffSelected.origin = {
            id: destination.id,
            cep: origin.cep,
            logradouro: origin.logradouro,
            numero: origin.numero,
            complemento: origin.complemento,
            bairro: origin.bairro,
            cidade: origin.cidade,
            estado: origin.estado,
            latitude: origin.latitude,
            longitude: origin.longitude,
            // descricao: item.origem,
            descricao: origin.localParada,
          }
        }
      }
      // }

      if (item.tarifarioId == '' || !item.tarifarioId) {
        if (this.SearchTariffProposalComponent) {
          this.SearchTariffProposalComponent.fillPurchase(this.tariffSelected)
          // setTimeout(() => {
          //   this.SearchTariffProposalComponent.fillPurchase(this.tariffSelected)
          // }, 3000)
        }
      }

      // this.getServiceSpecification(item.tipoServicoId)
      // this.form.get('serviceType')!.setValue(item.tipoServicoId)
      // this.form.get('specificationService')!.setValue(item.servicoId)
      // this.form.get('vehicleType')!.setValue(item.tipoVeiculoId ?? '')
      // this.form.get('driverType')!.setValue(item.tipoMotoristaId ?? '')

      // this.form.get('origin')!.setValue(item.origemId)
      // this.form.get('destination')!.setValue(item.destinoId)

      this.form.get('cost')!.setValue(convertCurrency(item.custo))
      // this.form
      //   .get('costOvertime')!
      //   .setValue(convertCurrency(item.custoHoraExtra))
      // this.form.get('costKmExtra')!.setValue(convertCurrency(item.custoKmExtra))

      this.form.get('saleUnit')!.setValue(convertCurrency(item.valorUnitario))
      this.form
        .get('saleOvertime')!
        .setValue(convertCurrency(item.valorHoraVenda))
      this.form.get('saleKmExtra')!.setValue(convertCurrency(item.valorKmVenda))

      this.form
        .get('dateStart')!
        .setValue(moment(item.dataInicio, 'DD/MM/YYYY').toDate())
      this.form
        .get('timeStart')!
        .setValue(!item.horaInicio ? '' : item.horaInicio.slice(0, 5))
      this.form
        .get('dateEnd')!
        .setValue(moment(item.dataFinal, 'DD/MM/YYYY').toDate())
      this.form
        .get('timeEnd')!
        .setValue(!item.horaFinal ? '' : item.horaFinal.slice(0, 5))

      this.form
        .get('isCourtesy')!
        .setValue(item.isCortesia == 'S' ? true : false)
      this.form
        .get('isCommission')!
        .setValue(item.isComissiona == 'S' ? true : false)
      this.form
        .get('isExchange')!
        .setValue(item.isPermuta == 'S' ? true : false)

      this.form.get('numVehicle')!.setValue(item.quantidadeVeiculos)
      this.form.get('numPeople')!.setValue(item.quantidadePassageiros)

      this.form.get('saleTotal')!.setValue(convertCurrency(item.valorVenda))
      this.form.get('taxValue')!.setValue(convertCurrency(item.valorTaxa))
      this.form
        .get('saleTotalTax')!
        .setValue(convertCurrency(item.valorComTaxa))

      this.form.get('typeCommission')!.setValue(item.tipoDivisor)
      this.fillCommission({
        taxa: item.taxa,
        divisor: item.divisor,
        comissao: item.comissao,
      })

      this.form.get('observation')!.setValue(item.observacao)
      // this.listItineraries = item.intinerarios

      this.blockField(true)

      // if (item.tarifario.id != '') {
      //   this.tariffSelected = item.tarifario
      //   this.fillTariff(this.tariffSelected)
      //   this.form.get('origin')?.disable()
      //   this.form.get('destination')?.disable()
      //   this.form.get('serviceType')?.disable()
      //   this.form.get('specificationService')?.disable()
      //   this.form.get('vehicleType')?.disable()
      //   this.form.get('driverType')?.disable()
      //   this.form.get('cost')?.disable()
      //   this.form.get('costOvertime')?.disable()
      //   this.form.get('costKmExtra')?.disable()
      // }
    }
  }

  createModel() {
    let model: any = {}
    let tariff: any = {}

    console.log('this.tariffSelected.id: ', this.tariffSelected)

    if (
      this.tariffSelected.id &&
      this.tariffSelected.id != '' &&
      this.tariffSelected.id != null &&
      this.tariffSelected.id != -1
    ) {
      tariff = {
        origem: this.tariffSelected.origem,
        destino: this.tariffSelected.destino,
        tipoServico: this.tariffSelected.tipoServico,
        servico: this.tariffSelected.servico,
        tipoVeiculo: this.tariffSelected.tipoVeiculo,
        tipoMotorista: this.tariffSelected.tipoMotorista,

        tarifario: this.tariffSelected,
        tarifarioId: this.tariffSelected.id,
        tipoTarifarioId: this.tariffSelected.tipoId,

        origemId: this.tariffSelected.origemId,
        destinoId: this.tariffSelected.destinoId,
        tipoServicoId: this.tariffSelected.tipoServicoId,
        servicoId: this.tariffSelected.servicoId,
        tipoVeiculoId: this.tariffSelected.tipoVeiculoId,
        tipoMotoristaId: this.tariffSelected.tipoMotoristaId,

        origin: this.tariffSelected.origin,
        destination: this.tariffSelected.destination,
        perimetroUrbano: this.tariffSelected.perimetroUrbano,
      }
    } else {
      let tarrifInfos = this.SearchTariffProposalComponent.createPurchase()
      console.log('tarrifInfos: ', tarrifInfos)

      tariff = {
        origem: tarrifInfos.origem,
        destino: tarrifInfos.destino,
        tipoServico: tarrifInfos.tipoServico,
        servico: tarrifInfos.servico,
        tipoVeiculo: tarrifInfos.tipoVeiculo,
        tipoMotorista: tarrifInfos.tipoMotorista,

        tarifario: tarrifInfos,

        tipoTarifarioId: tarrifInfos.tipoTarifarioId,

        origemId: tarrifInfos.origemId,
        destinoId: tarrifInfos.destinoId,
        tipoServicoId: tarrifInfos.tipoServicoId,
        servicoId: tarrifInfos.servicoId,
        tipoVeiculoId: tarrifInfos.tipoVeiculoId,
        tipoMotoristaId: tarrifInfos.tipoMotoristaId,

        origin: tarrifInfos.origin,
        destination: tarrifInfos.destination,
        perimetroUrbano: tarrifInfos.perimetroUrbano,
      }
    }
    console.log('teste', tariff)

    let divisor =
      typeof this.form.get('divider')?.value == 'string'
        ? convertCurrency(this.form.get('divider')?.value)
        : this.form.get('divider')?.value
    if (divisor == 0 || divisor == null) {
      divisor = 1
    }

    model = {
      // propostaId: this.item.data.id,
      propostaId: this.item.propostaId,
      tarifarioId:
        tariff.tarifarioId && tariff.tarifarioId != ''
          ? tariff.tarifarioId
          : null,
      tipoTarifarioId:
        tariff.tipoTarifarioId && tariff.tipoTarifarioId != ''
          ? tariff.tipoTarifarioId
          : null,
      origemId: tariff.origemId,
      destinoId: tariff.destinoId,
      tipoServicoId: tariff.tipoServicoId,
      servicoId: tariff.servicoId,
      tipoVeiculoId: tariff.tipoVeiculoId ?? 0,
      tipoMotoristaId: tariff.tipoMotoristaId ?? 0,
      numPessoas: parseInt(this.form.get('numPeople')?.value),
      numVeiculos: parseInt(this.form.get('numVehicle')?.value),
      valorUnitario: this.form.get('saleUnit')?.value
        ? convertCurrency(this.form.get('saleUnit')?.value)
        : 0,
      valorVenda: this.form.get('saleTotal')?.value
        ? convertCurrency(this.form.get('saleTotal')?.value)
        : 0,
      valorComTaxa: this.form.get('saleTotalTax')?.value
        ? convertCurrency(this.form.get('saleTotalTax')?.value)
        : 0,
      valorTaxa: this.form.get('taxValue')?.value
        ? convertCurrency(this.form.get('taxValue')?.value)
        : 0,
      valorKmVenda: this.form.get('saleKmExtra')?.value
        ? convertCurrency(this.form.get('saleKmExtra')?.value)
        : 0,
      valorHoraVenda: this.form.get('saleOvertime')?.value
        ? convertCurrency(this.form.get('saleOvertime')?.value)
        : 0,
      isPermuta: this.form.get('isExchange')?.value ? 'S' : 'N',
      isComissiona: this.form.get('isCourtesy')?.value ? 'S' : 'N',
      isCortesia: this.form.get('isCommission')?.value ? 'S' : 'N',
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      horaInicio:
        this.form.get('timeStart')?.value == ''
          ? ''
          : this.form.get('timeStart')?.value + ':00',
      dataFinal: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      horaFinal:
        this.form.get('timeStart')?.value == ''
          ? ''
          : this.form.get('timeStart')?.value + ':00',
      taxa: convertCurrency(this.form.get('tax')?.value),
      divisor: divisor,
      comissao: convertCurrency(this.form.get('commission')?.value),
      tipoDivisor: this.form.get('typeCommission')?.value,
      observacao: this.form.get('observation')?.value,
      itinerarios: this.getItineraries(tariff),
      perimetroUrbano: tariff.perimetroUrbano,
    }
    return model
  }

  getItineraries(tariff: any) {
    console.log('item: ', this.listItineraries)
    let model: any[] = []
    for (let index = 0; index < this.listItineraries.length; index++) {
      const element = this.listItineraries[index]
      model.push({
        localParada: element.descricao,
        cep: element.cep,
        logradouro: element.logradouro,
        numero: element.numero,
        bairro: element.bairro,
        complemento: element.complemento,
        cidade: element.cidade,
        estado: element.estado,
        latitude: element.latitude != '' ? element.latitude : null,
        longitude: element.longitude != '' ? element.latitude : null,
        trecho: element.trecho,
        areaTarifario:
          element.areaTarifario == 'S' || element.areaTarifario == 's'
            ? 'S'
            : 'N',
      })
    }

    if (
      // tariff.origin.cep != '' &&
      // tariff.origin.logradouro != '' &&
      // tariff.origin.numero != '' &&
      // tariff.origin.bairro != '' &&
      tariff.origin.cidade != '' &&
      tariff.origin.estado != ''
    ) {
      model.push({
        // localParada: 'Origem',
        localParada: tariff.origin.descricao,
        cep: tariff.origin.cep,
        logradouro: tariff.origin.logradouro,
        numero: tariff.origin.numero,
        bairro: tariff.origin.bairro,
        latitude: tariff.origin.latitude != '' ? tariff.origin.latitude : null,
        longitude:
          tariff.origin.longitude != '' ? tariff.origin.longitude : null,
        cidade: tariff.origin.cidade,
        estado: tariff.origin.estado,
        complemento: tariff.origin.complemento,
        trecho: 'O',
        areaTarifario: 'S',
        // descricao: tariff.origin.descricao,
        descricao: tariff.origin.cidade,
      })
    }

    if (
      // tariff.destination.cep != '' &&
      // tariff.destination.logradouro != '' &&
      // tariff.destination.numero != '' &&
      // tariff.destination.bairro != '' &&
      tariff.destination.cidade != '' &&
      tariff.destination.estado != ''
    ) {
      model.push({
        localParada: tariff.destination.descricao,
        cep: tariff.destination.cep,
        logradouro: tariff.destination.logradouro,
        numero: tariff.destination.numero,
        bairro: tariff.destination.bairro,
        latitude:
          tariff.destination.latitude != ''
            ? tariff.destination.latitude
            : null,
        longitude:
          tariff.destination.longitude != ''
            ? tariff.destination.longitude
            : null,
        cidade: tariff.destination.cidade,
        estado: tariff.destination.estado,
        complemento: tariff.destination.complemento,
        trecho: 'D',
        areaTarifario: 'S',
        // descricao: tariff.destination.descricao,
        descricao: tariff.destination.cidade,
      })
    }
    return model
  }

  createModelBkp() {
    console.log('this.tariffSelected', this.tariffSelected)

    if (
      this.tariffSelected.id == '' ||
      this.tariffSelected.id == null ||
      this.tariffSelected.id == -1
    ) {
      this.tariffSelected = this.SearchTariffProposalComponent.createPurchase()
    }
    console.log('this.tariffSelected', this.tariffSelected)

    let itineraries: any[] = []
    if (
      // this.tariffSelected.origin.cep != '' &&
      // this.tariffSelected.origin.logradouro != '' &&
      // this.tariffSelected.origin.numero != '' &&
      // this.tariffSelected.origin.bairro != '' &&
      this.tariffSelected.origin.cidade != '' &&
      this.tariffSelected.origin.estado != ''
    ) {
      itineraries.push({
        // localParada: 'Origem',
        localParada: this.tariffSelected.origin.descricao,
        cep: this.tariffSelected.origin.cep,
        logradouro: this.tariffSelected.origin.logradouro,
        numero: this.tariffSelected.origin.numero,
        bairro: this.tariffSelected.origin.bairro,
        latitude:
          this.tariffSelected.origin.latitude != ''
            ? this.tariffSelected.origin.latitude
            : null,
        longitude:
          this.tariffSelected.origin.longitude != ''
            ? this.tariffSelected.origin.longitude
            : null,
        cidade: this.tariffSelected.origin.cidade,
        estado: this.tariffSelected.origin.estado,
        complemento: this.tariffSelected.origin.complemento,
        trecho: 'O',
        areaTarifario: 'S',
        // descricao: this.tariffSelected.origin.descricao,
        descricao: this.tariffSelected.origin.cidade,
      })
    }

    if (
      // this.tariffSelected.destination.cep != '' &&
      // this.tariffSelected.destination.logradouro != '' &&
      // this.tariffSelected.destination.numero != '' &&
      // this.tariffSelected.destination.bairro != '' &&
      this.tariffSelected.destination.cidade != '' &&
      this.tariffSelected.destination.estado != ''
    ) {
      itineraries.push({
        localParada: this.tariffSelected.destination.descricao,
        // localParada: 'Destino',
        cep: this.tariffSelected.destination.cep,
        logradouro: this.tariffSelected.destination.logradouro,
        numero: this.tariffSelected.destination.numero,
        bairro: this.tariffSelected.destination.bairro,
        latitude:
          this.tariffSelected.destination.latitude != ''
            ? this.tariffSelected.destination.latitude
            : null,
        longitude:
          this.tariffSelected.destination.longitude != ''
            ? this.tariffSelected.destination.longitude
            : null,
        cidade: this.tariffSelected.destination.cidade,
        estado: this.tariffSelected.destination.estado,
        complemento: this.tariffSelected.destination.complemento,
        trecho: 'D',
        areaTarifario: 'S',
        // descricao: this.tariffSelected.destination.descricao,
        descricao: this.tariffSelected.destination.cidade,
      })
    }

    let divisor =
      typeof this.form.get('divider')?.value == 'string'
        ? convertCurrency(this.form.get('divider')?.value)
        : this.form.get('divider')?.value
    if (divisor == 0 || divisor == null) {
      divisor = 1
    }

    let model: any = {
      id: this.item.id,
      propostaId: this.item.propostaId,
      // tarifarioId: this.tariffSelected.id,
      tarifarioId:
        this.tariffSelected.id && this.tariffSelected.id != ''
          ? this.tariffSelected.id
          : null,
      tipoTarifarioId: this.tariffSelected.tipoTarifarioid
        ? this.tariffSelected.tipoTarifarioid
        : this.tariffSelected.tipoId,
      origemId: this.tariffSelected.origemId,
      destinoId: this.tariffSelected.destinoId,
      tipoServicoId: this.tariffSelected.tipoServicoId,
      servicoId: this.tariffSelected.servicoId,
      tipoVeiculoId: this.tariffSelected.tipoVeiculoId ?? 0,
      tipoMotoristaId: this.tariffSelected.tipoMotoristaId ?? 0,
      perimetroUrbano: this.tariffSelected.perimetroUrbano,
      statusId: this.item.statusId,
      NumVeiculos: parseInt(this.form.get('numVehicle')?.value),
      NumPessoas: parseInt(this.form.get('numPeople')?.value),
      vendaSemTaxa: this.form.get('saleTotal')?.value
        ? convertCurrency(this.form.get('saleTotal')?.value)
        : 0,
      valorTaxa: this.form.get('taxValue')?.value
        ? convertCurrency(this.form.get('taxValue')?.value)
        : 0,
      venda: this.form.get('saleTotalTax')?.value
        ? convertCurrency(this.form.get('saleTotalTax')?.value)
        : 0,
      valorHoraExtra: this.form.get('saleOvertime')?.value
        ? convertCurrency(this.form.get('saleOvertime')?.value)
        : 0,
      valorKmExtra: this.form.get('saleKmExtra')?.value
        ? convertCurrency(this.form.get('saleKmExtra')?.value)
        : 0,
      valorUnitario: this.form.get('saleUnit')?.value
        ? convertCurrency(this.form.get('saleUnit')?.value)
        : 0,
      isPermuta: this.form.get('isExchange')?.value ? 'S' : 'N',
      isCortesia: this.form.get('isCourtesy')?.value ? 'S' : 'N',
      IsComissionado: this.form.get('isCommission')?.value ? 'S' : 'N',
      dataInicio: moment(this.form.get('dateStart')!.value).format(
        'DD/MM/YYYY',
      ),
      horaInicio:
        this.form.get('timeStart')?.value == ''
          ? ''
          : this.form.get('timeStart')?.value + ':00',

      dataFinal: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
      horaFinal:
        this.form.get('timeEnd')?.value == ''
          ? ''
          : this.form.get('timeEnd')?.value + ':00',
      taxa: convertCurrency(this.form.get('tax')?.value),
      divisor: divisor,
      comissao: convertCurrency(this.form.get('commission')?.value),
      tipoDivisor: this.form.get('typeCommission')?.value,
      observacao: this.form.get('observation')?.value,
    }
    if (itineraries.length > 0) {
      model = { ...model, itinerarios: itineraries }
    }

    return model
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariff: [''],

      isCourtesy: [false],
      isCommission: [false],
      isExchange: [false],

      dateStart: ['', [Validators.required]],
      timeStart: [''],
      dateEnd: ['', [Validators.required]],
      timeEnd: [''],

      typeCommission: [0],
      commission: ['', [Validators.required]],
      divider: ['', [Validators.required]],
      tax: ['', [Validators.required]],

      numVehicle: [1, [Validators.min(1), Validators.required]],
      numPeople: [1, [Validators.min(1), Validators.required]],

      cost: ['', [Validators.required]],
      sale: [''],
      // costOvertime: ['', [Validators.required]],
      // costKmExtra: ['', [Validators.required]],

      saleUnit: ['', [Validators.required]],
      saleOvertime: ['', [Validators.required]],
      saleKmExtra: ['', [Validators.required]],

      saleTotal: ['', [Validators.required]],
      taxValue: ['', [Validators.required]],
      saleTotalTax: ['', [Validators.required]],

      observation: [''],
    })
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    let specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  addTariff() {
    const dialogRef = this.dialog.open(ModalTariffProposalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {
        idClient: this.idClient,
        item: this.tariffSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.tariffSelected = response.selection
          this.fillTariff(this.tariffSelected)
        } else {
          this.tariffSelected = {}
          this.form.get('tariff')!.setValue('')
          this.clearTariff()
        }
      }
    })
  }

  fillTariff(item: any) {
    let label = `O: ${item.origem} | D:  ${item.destino} | Serviço:  ${item.servico} | Custo:  R$ ${convertCurrency(item.custo)}`
    this.form.get('tariff')!.setValue(label)
    this.getServiceSpecification(item.tipoServicoId)
    this.form.get('origin')!.setValue(item.origemId)
    this.form.get('destination')!.setValue(item.destinoId)
    this.form.get('serviceType')!.setValue(item.tipoServicoId)
    this.form.get('specificationService')!.setValue(item.servicoId)
    this.form.get('vehicleType')!.setValue(item.tipoVeiculoId)
    this.form.get('driverType')!.setValue(item.tipoMotoristaId)
    this.form.get('cost')!.setValue(convertCurrency(item.custo))
    this.form
      .get('costOvertime')!
      .setValue(convertCurrency(item.custoHoraExtra))
    this.form.get('costKmExtra')!.setValue(convertCurrency(item.custokmExtra))
    this.form.get('origin')?.disable()
    this.form.get('destination')?.disable()
    this.form.get('serviceType')?.disable()
    this.form.get('specificationService')?.disable()
    this.form.get('vehicleType')?.disable()
    this.form.get('driverType')?.disable()
    this.form.get('cost')?.disable()
    this.form.get('costOvertime')?.disable()
    this.form.get('costKmExtra')?.disable()
  }

  clearTariff() {
    this.form.get('origin')!.setValue('')
    this.form.get('origin')?.enable()
    this.form.get('destination')!.setValue('')
    this.form.get('destination')?.enable()
    this.form.get('serviceType')!.setValue('')
    this.form.get('serviceType')?.enable()
    this.form.get('specificationService')!.setValue('')
    this.form.get('specificationService')?.enable()
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')?.enable()
    this.form.get('driverType')!.setValue('')
    this.form.get('driverType')?.enable()
    this.form.get('cost')!.setValue('')
    this.form.get('cost')?.enable()
    this.form.get('costOvertime')!.setValue('')
    this.form.get('costOvertime')?.enable()
    this.form.get('costKmExtra')!.setValue('')
    this.form.get('costKmExtra')?.enable()
  }

  getList(list: any[]): void {
    this.listItineraries = list
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  treatmentType(typeId: number = 0) {
    if (typeId == 2) {
      this.form.get('typeCommission')?.setValue('P')
      // this.form.get('typeCommission')?.disable()
      this.form.get('commission')?.setValue(convertCurrency(0))
      this.form.get('commission')?.enable()
      this.form.get('divider')?.setValue(convertCurrency(1))
      this.form.get('divider')?.enable()
      this.form.get('tax')?.setValue(convertCurrency(5))
      this.form.get('tax')?.enable()
    } else {
      this.form.get('typeCommission')?.enable()
    }
  }

  selectTariff(element: any) {
    if (element.id != -1) {
      if (element.tipoTarifarioId == 2 || element.tipoId == 2) {
        this.treatmentType(2)
      }
      this.form.get('cost')?.setValue(convertCurrency(element.custo))
      this.form
        .get('saleOvertime')!
        .setValue(convertCurrency(element.custoHoraExtra))
      this.form
        .get('saleKmExtra')!
        .setValue(convertCurrency(element.custokmExtra))

      // this.form
      //   .get('saleOvertime')
      //   ?.setValue(convertCurrency(element.custoHoraExtra))
      // this.form
      //   .get('saleKmExtra')
      //   ?.setValue(convertCurrency(element.custokmExtra))
      this.calculateValues()
    } else {
      this.treatmentType()
      this.form.get('cost')?.setValue(convertCurrency(0))
      this.form.get('saleOvertime')?.setValue(convertCurrency(0))
      this.form.get('saleKmExtra')?.setValue(convertCurrency(0))
    }
    this.tariffSelected = element
    this.calculateValues()
  }

  locationTariff(element: any) {
    this.tariffSelected = { ...this.tariffSelected, ...element }
  }

  blockField(block: boolean = false) {
    this.form.get('cost')?.disable()
    this.form.get('costOvertime')?.disable()
    this.form.get('costKmExtra')?.disable()

    this.form.get('sale')?.disable()
    this.form.get('saleOvertime')?.disable()
    this.form.get('saleKmExtra')?.disable()

    this.form.get('saleUnit')?.disable()
    this.form.get('saleTotal')?.disable()
    this.form.get('saleTotalTax')?.disable()
    this.form.get('taxValue')?.disable()
  }

  getValueNumber(value: string | number) {
    if (typeof value == 'string') {
      return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
    } else if (typeof value == 'number') {
      return value
    } else {
      return 0.0
    }
  }

  calculateValues() {
    let divider = this.getValueNumber(
      this.form.get('divider')?.value == '' ||
        this.form.get('divider')?.value == '0'
        ? 1
        : this.form.get('divider')?.value,
    )
    let tax = this.getValueNumber(this.form.get('tax')?.value)
    let commission = this.getValueNumber(this.form.get('commission')?.value)
    let cost = this.getValueNumber(this.form.get('cost')?.value)
    // let costKm = this.getValueNumber(this.form.get('costKmExtra')?.value)
    // let costTime = this.getValueNumber(this.form.get('costOvertime')?.value)
    let vehicles = parseInt(this.form.get('numVehicle')?.value)

    // let saleKm = parseFloat((costKm + costKm / divider).toFixed(2))
    // let saleTime = parseFloat((costTime + costTime / divider).toFixed(2))
    let saleUnit = 0
    if (typeof cost == 'string') {
      // @ts-ignore
      cost = parseFloat(cost)
    }
    if (typeof divider == 'string') {
      // @ts-ignore
      divider = parseFloat(divider)
    }
    saleUnit = cost / divider
    saleUnit = Math.ceil(!isFinite(saleUnit) ? 0 : (saleUnit ?? 0))

    let sale = 0
    sale = saleUnit * vehicles
    sale = Math.ceil(!isFinite(sale) ? 0 : (sale ?? 0))

    let taxValue = 0
    console.log(tax)
    if (typeof tax == 'string') {
      // @ts-ignore
      tax = parseFloat(tax)
    }
    console.log(tax)
    taxValue = (sale * tax) / 100
    taxValue = Math.ceil(!isFinite(taxValue) ? 0 : (taxValue ?? 0))

    let saleTax = sale + taxValue
    saleTax = Math.ceil(!isFinite(saleTax) ? 0 : (saleTax ?? 0))

    this.form
      .get('saleUnit')
      ?.setValue(
        isNaN(saleUnit) ? convertCurrency(0) : convertCurrency(saleUnit),
      )
    this.form
      .get('saleTotal')
      ?.setValue(isNaN(sale) ? convertCurrency(0) : convertCurrency(sale))
    this.form
      .get('taxValue')
      ?.setValue(
        isNaN(taxValue) ? convertCurrency(0) : convertCurrency(taxValue),
      )
    this.form
      .get('saleTotalTax')
      ?.setValue(isNaN(saleTax) ? convertCurrency(0) : convertCurrency(saleTax))

    // this.form
    //   .get('saleUnit')
    //   ?.setValue(isNaN(saleUnit) ? '' : convertCurrency(saleUnit))
    // this.form
    //   .get('saleTotal')
    //   ?.setValue(isNaN(sale) ? '' : convertCurrency(sale))
    // this.form
    //   .get('taxValue')
    //   ?.setValue(isNaN(taxValue) ? '' : convertCurrency(taxValue))
    // this.form
    //   .get('saleTotalTax')
    //   ?.setValue(isNaN(saleTax) ? '' : convertCurrency(saleTax))

    // this.form.get('saleKmExtra')?.setValue(convertCurrency(saleKm))
    // this.form.get('saleOvertime')?.setValue(convertCurrency(saleTime))

    // let divider = this.getValueNumber(this.form.get('divider')?.value)
    // let tax = this.getValueNumber(this.form.get('tax')?.value)
    // let commission = this.getValueNumber(this.form.get('commission')?.value)
    // let cost = this.getValueNumber(this.form.get('cost')?.value)
    // let costKm = this.getValueNumber(this.form.get('costKmExtra')?.value)
    // let costTime = this.getValueNumber(this.form.get('costOvertime')?.value)
    // let vehicles = parseInt(this.form.get('numVehicle')?.value)
    //
    // let saleUnit = parseFloat((cost + cost / divider).toFixed(2))
    // let saleKm = parseFloat((costKm + costKm / divider).toFixed(2))
    // let saleTime = parseFloat((costTime + costTime / divider).toFixed(2))
    // let sale = parseFloat((saleUnit * vehicles).toFixed(2))
    // let saleTax = parseFloat((sale + (sale * tax) / 100).toFixed(2))
    // let taxValue = parseFloat((saleTax - sale).toFixed(2))
    //
    // this.form.get('saleUnit')?.setValue(convertCurrency(saleUnit))
    // this.form.get('saleKmExtra')?.setValue(convertCurrency(saleKm))
    // this.form.get('saleOvertime')?.setValue(convertCurrency(saleTime))
    //
    // this.form.get('saleTotal')?.setValue(convertCurrency(sale))
    // this.form.get('taxValue')?.setValue(convertCurrency(taxValue))
    // this.form.get('saleTotalTax')?.setValue(convertCurrency(saleTax))
  }
}
